export default {
  su_email: 'Email',
  su_pwd: 'Password',
  su_confirm: 'Confirm password',
  su_already_have_an_account: 'Already have an account?',
  su_sign_in: 'Sign in now',
  su_sign_up: 'Sign up',
  su_documents_text: 'By clicking the SIGN UP button, you accept the',
  su_documents_user_agreement: 'User agreement,',
  su_documents_terms_service: 'Terms of service,',
  su_documents_privacy_policy: 'Privacy Policy.'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/signup_view.js